var _path, _path2, _mask, _g, _path3, _path4, _ellipse, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 100,
    viewBox: "0 0 120 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 0H0v100h120V0z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105 49.99C105 74.85 84.84 95 59.99 95c-9.72 0-18.7-3.08-26.05-8.31-2.13-1.52-4.11-3.21-5.94-5.06-8.03-8.13-13-19.31-13-31.64C15 25.15 35.13 5 59.99 5 84.85 5 105 25.13 105 49.99z",
    fill: "#F0F1F2"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 5,
    width: 90,
    height: 90
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 95c24.853 0 45-20.147 45-45S84.853 5 60 5 15 25.147 15 50s20.147 45 45 45z",
    fill: "#F0F1F2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.8 57.49h42.93V97.5H61.8V57.49z",
    fill: "#D9942D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 57.49h42.932V97.5H45V57.49z",
    fill: "#E9AF58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.99 57.49h10.773v6.742H60.99v-6.74zM94.154 57.49h6.844v6.96h-6.844v-6.96z",
    fill: "#C6965F"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.448 7S59.068 9.5 49.5 9.5C39.932 9.5 35.552 7 35.552 7L5 18.25l3.985 17.5L25.025 32v40h48.95V32l16.04 3.75L94 18.25 63.448 7z",
    fill: "#5BA7B1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.358 7c0 5.547-6.166 9.985-13.873 9.985-7.488 0-13.654-4.438-13.654-9.985 0 0 4.295 1.362 13.765 1.362S63.358 7 63.358 7z",
    fill: "#3C8B96"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.486,
    cy: 41.361,
    rx: 8.841,
    ry: 8.908,
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.647 26.97l8.834 15.418H45.813l8.835-15.418z",
    fill: "#E9AF58"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstall);
export default __webpack_public_path__ + "static/media/install.c7106e1793422b8a1f3c1c65da49f913.svg";
export { ForwardRef as ReactComponent };